<app-base-doughnut-chart
  [chartId]="chartId"
  [title]="title"
  [labels]="labels"
  [data]="data"
  [colors]="colors"
  legendPosition="top"
>
</app-base-doughnut-chart>
